
import {IUserLogEntryBuilder} from './i.user.log.entry.builder';
import {IUserLogEntryOptions} from './i.user.log.entry.options';

/**
 *
 * @class CommitSnapshotBuilder
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2021
 *
 */
export class CommitSnapshotBuilder implements IUserLogEntryBuilder {

  /** convert raw MongoDB user log entry into data that can construct a tree node */
  build(data: any, args: IUserLogEntryOptions): any {

    const u:        string = data._id.match(/^cc-snap-(.*)/i)[1];
    const dir:      string = data.r ? 'REV' : 'FWD';
    let train:         any = null;
    const depDir:   string = data.sn.dd;

    let children: any[]    = [];

    /*
     * the snapshot includes a list of interlinks, and in each interlink "bucket", there will
     * be a list of trains that were dragged to that track bundle.  So we have two levels of
     * children to add, the internlinks and the train lists.
     *
     */

    data.sn.il.forEach((interlink: any, ii: number) => {

      /* build out the train list inside the interlink */

      let trainList: any = [];

      interlink.tl.forEach((trackTrain: any, ti: number) => {

        let before: any    = null;
        let after: any     = null;

        if (trackTrain.tk.a != null) {

          after = {
            name:    trackTrain.tk.a.d,
            mileage: trackTrain.tk.a.m
          };
        }

        if (trackTrain.tk.b != null) {

          before = {
            name:    trackTrain.tk.b.d,
            mileage: trackTrain.tk.b.m
          };
        }

        const track: any = {
          id:      trackTrain.tk.i,
          track:   trackTrain.tk.t,
          mileage: trackTrain.tk.m,
          before,
          after
        };

        const train: any = {

          name:            `${trackTrain.tr.n}-${trackTrain.tr.d} [ ${trackTrain.tr.src.n} - ${trackTrain.tr.dst.n} ] ${trackTrain.tr.tp}-${trackTrain.tr.u}`,
          type:            'train',
          children:        [],
          uuid:            trackTrain.tr.u,
          kind:            trackTrain.tr.tp,
          direction:       trackTrain.tr.d,
          source: {
            name:          trackTrain.tr.src.n,
            mileage:       trackTrain.tr.src.m
          },
          destination: {
            name:          trackTrain.tr.dst.n,
            mileage:       trackTrain.tr.dst.m
          },
          trainClass:      trackTrain.tr.tc,
          tonnage:         trackTrain.tr.ton,
          length:          trackTrain.tr.l,
          priority:        trackTrain.tr.pri,
          overtake:        trackTrain.tr.o,
          u:               trackTrain.tr._id
        };

        trainList.push({
          id:              `snap-train-track-${data._id}-${ti}`,
          name:            `${train.name} ${track.track}`,
          hasChildren:     false,
          isExpanded:      true,
          type:            'snap-train-track',
          children:        [],
          pkey:          `snap-interlink-${data._id}-${ii}`,
          track,
          train,
        });

      });

      /* build and save the interlink parent */

      children.push({
        id:              `snap-interlink-${data._id}-${ii}`,
        name:            interlink.l.n,
        hasChildren:     trainList.length > 0,
        isExpanded:      true,
        type:            'snapshot-interlink',
        children:        trainList,
        pkey:            data._id,
        kind:            interlink.l.k,
        index:           interlink.l.ix,
        sIndex:          interlink.l.sx
      });

    });

    if (data.tr) {

      train = {
        id:              data._id,
        name:            `${data.tr.n}-${data.tr.d} [ ${data.tr.src.n} - ${data.tr.dst.n} ] ${data.tr.tp}-${data.tr.u}`,
        type:            'train',
        children:        [],
        uuid:            data.tr.u,
        kind:            data.tr.tp,
        direction:       data.tr.d,
        source: {
          name:          data.tr.src.n,
          mileage:       data.tr.src.m
        },
        destination: {
          name:          data.tr.dst.n,
          mileage:       data.tr.dst.m
        },
        trainClass:      data.tr.tc,
        tonnage:         data.tr.ton,
        length:          data.tr.l,
        priority:        data.tr.pri,
        overtake:        data.tr.o,
        u:               data.tr._id
      };
    }

    return {
      id:              data._id,
      seq:             parseInt(data.seq),
      name:            `Commit Queue: ${data.tx}`,
      hasChildren:     children.length > 0,
      isExpanded:      false,
      type:            'commit-snapshot',
      children,
      parent:          args.parent,
      kids:            data.ch,
      tags:            data.tg,
      label:           data.lb,
      pkey:            data.pa,
      direction:       dir,
      deploymentDir:   depDir,
      train,
      u:               data._id
    };

  }
}
